<!-- /src/views/Dashboard.vue -->
<template>
  <div class="dashboard-funnel">
    <div class="bg-image--container">
      <div class="bg-image"
        :style="'background-image: url(' + bgImage + ')'"></div>
    </div>
    <div class="layout__content">
      <div class="dashboard-columns">
      <nav
        class="nav-list"
      >
        <div class="nav-list--item"
          v-for="(item, index) in navList" :key="index"
        >
          <router-link
            v-if="!(linkType(item))"
            :class="item.href == '/sessions/training-overview/' ? 'nav-list--link bg-color--orange' : 'nav-list--link'"
            :to="item.href"
          ><img v-if="item.icon" 
              :src="item.icon"
              :title="item.title">
            <span 
              class="nav-list--link--title"
              :class="{'nav-list--link--title--has-icon': item.icon}"
            >{{ item.title }}</span>
          </router-link>
          <a
            v-else
            class="nav-list--link"
            :href="item.href"
            target="_blank"
            v-html="item.title"
            ></a>
        </div>
      </nav>
      <AskCarrAiPanel class="dashboard-ai-panel" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LayoutTwoColumn from '@/components/layouts/TwoColumn-SidebarNarrow'
import CardGrid from '@/components/common/Card/CardGrid'
import Loader from '@/components/common/Loaders/Loader'
import AskCarrAiPanel from '@/components/common/AskCarrAi/AskCarrAiPanel'
import SidebarMenu from '@/components/common/Sidebar/Menu'
import UserMenu from '@/components/common/Sidebar/User'
// import Pagination from '@/components/common/Pagination'

export default {
  name: 'dashboard',

  data() {
    return {
      userGroups: [],
      userDivisions: [],
      userCompleted: [],
      contentClasses: 'padding-top',
      bgImage: '',
      // funnel: {},
    }
  },

  computed: {
    funnel() {
      const funnelSlug = typeof(this.$route.params.slug) != 'undefined' ? this.$route.params.slug : 'dashboard'
      // console.log(funnelSlug)
      const funnel = this.$store.getters['posts/findFunnelsByProp'](
        'funnels',
        funnelSlug,
        'slug',
      )

      if (funnel) {
        const pageTitle = funnel.name == 'Dashboard' ? funnel.name : funnel.name + ' Dashboard'
        this.$store.dispatch('updatePageTitle', pageTitle)
      }

      if (funnel && funnel.hasOwnProperty('bg_image')) {
        this.bgImage = funnel.bg_image
        this.$store.dispatch('updateBackgroundImage', funnel.bg_image)
        this.$store.dispatch('updateBackgroundDark', true)
      }
      return funnel
    },
    navList() {
      const { funnel } = this
      // console.log(funnel)
      return funnel.children
    },

    ...mapGetters({
      user: 'user/getUser',
    }),
  },

  components: {
    LayoutTwoColumn,
    CardGrid,
    SidebarMenu,
    UserMenu,
    Loader,
    AskCarrAiPanel,
  },

  methods: {

    linkType(link) {
      const { href } = link
      return href.includes('http') || href.includes('//');
    },
  },

  beforeMount() {
    this.userCompleted = this.$store.getters['user/getCompleted']
    const { user_divisions, user_groups } = this.$store.getters[
      'user/getCustomFields'
    ]
    this.userDivisions = user_divisions
    this.userGroups = user_groups
  },

  beforeDestroy() {
    this.$store.dispatch('updateBackgroundImage', false)
    this.$store.dispatch('updateBackgroundDark', false)
    this.$store.dispatch('updateHeaderRev', false)
  }
}
</script>

<style scoped>

.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  /* filter: blur(6px);
  transform: scale(1.05); */
  &--container {
    overflow: hidden;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
  }
}

.dashboard-funnel {
  width: 100%;
  /* height: 100%; */
  display: grid;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;

  @media(--phone) {
    width: 100vw;
  }

  .layout__content {
    max-width: var(--desktop-width);
    width: 100%;
    margin: 0 auto;

    @media(--phone) {
      padding: 0 var(--itemSpacing);
    }
  }
  
}

.dashboard-columns {
  /* Grid for exact column control: nav flexes, panel fixed at 300px.
     Column gap matches the nav tile gap (single spacing source). */
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  /* gap (not column-gap): the row half applies when the panel stacks
     below the nav on mobile; inert in the single-row desktop layout. */
  gap: calc(var(--itemSpacing) / 3);
  /* 2rem on all sides, all widths (tablet horizontal doubling removed). */
  padding: var(--itemSpacing);

  .nav-list {
    width: 100%;
  }

  .dashboard-ai-panel {
    width: 100%;
  }

  /* Mobile: panel stacks below the nav (source order). */
  @media (max-width: 1100px) {
    grid-template-columns: minmax(0, 1fr);
  }
}

.nav-list {

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(155px, 1fr));
  /* Tile spacing via gap (was per-item padding); keeps 5 columns on
     desktop and centers gracefully when wrapping. */
  gap: calc(var(--itemSpacing) / 3);
  align-content: stretch;
  justify-content: stretch;
  width: 100%;

  /* Desktop (>=950px): flex with FIXED-SIZE 155px tiles - client
     requirement (buttons must not stretch). Wraps to 5 columns at
     desktop content width and centers when overfilled. */
  @media(--tablet-landscape) {
    display: flex;
    flex-wrap: wrap;
    -webkit-box-pack: center;
    justify-content: center;
  }


  &--link {
    &--title {
      display: block;
      &--has-icon {
        margin-top: .5em;
      }
    }
  }

  &--item {
    display: grid;
    justify-content: stretch;
    align-content: stretch;

    /* Desktop: fixed 155px tiles (client requirement - do not stretch). */
    @media(--tablet-landscape) {
      display: grid;
      grid-auto-columns: 154px;
      grid-auto-rows: 154px;
      width: initial;
    }

    a {
      display: grid;
      align-content: center;
      justify-content: center;
      width: 100%;
      background-color: rgba(var(--brandPrimary-RGB), .7);
      color: white;
      padding: calc(var(--itemSpacing) / 2);
      /* Matches the Ask CARR AI panel radius (8px). */
      border-radius: 8px;
      transition: all .5s;
      text-align: center;
      &:hover {
        color: var(--brandPrimary);
        background-color: rgba(255, 255, 255, .8);
      }

      &.bg-color--orange {
        background-color: rgba(var(--brandAccent-RGB), .7);
        &:hover {
          color: var(--brandPrimary);
          background-color: rgba(255, 255, 255, .8);
        }
      }
      
      img {
        width: 40%;
        margin: auto;
        height: auto;
      }
    }
  }
}
.card-grid-header,
.card-grid-footer {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  margin-bottom: 1rem;

  h2 {
    margin-bottom: 0;
  }

  &__actions {
    font-size: 0.7em;
  }
}

.card-grid-footer {
  justify-items: end;
}
</style>
